import { HOME } from "@/constants/testIds";

export default function HeroHeadline() {
  return (
    <>
      <div className="text-[11px] tracking-[0.28em] uppercase text-ivory/85 mb-10 opacity-0 animate-[fade-up_0.9s_0.4s_forwards] font-medium">
        India · Nepal · Bhutan · Sri Lanka
      </div>
      <h1
        data-testid={HOME.heroTitle}
        aria-label="Unfold The Extraordinary"
        className="font-serif text-[11vw] md:text-[6vw] leading-[0.95] tracking-tighter text-ivory font-light"
      >
        <span aria-hidden="true" className="block opacity-0 animate-[fade-up_1s_0.6s_forwards]">
          Unfold
        </span>
        <span className="sr-only"> </span>
        <span
          aria-hidden="true"
          className="block italic font-light opacity-0 animate-[fade-up_1s_0.85s_forwards] text-goldleaf"
        >
          The Extraordinary
        </span>
      </h1>
      <p className="mt-10 max-w-xl text-ivory/85 text-base md:text-lg leading-relaxed font-light opacity-0 animate-[fade-up_0.9s_1.1s_forwards]">
        Indiora Journeys composes refined, private travel through the
        cultural heart of South Asia — for those who travel as a way of
        listening, not collecting.
      </p>
    </>
  );
}
